import React from 'react';
import Entry from '../components/Entry';
import EntryConfig from '../components/entryconfigType';
import '../Default.css';


const menuItems: EntryConfig[] = [
  {
    img:"/icons/section-solid.svg",
    img_alt: "rules",
    link: "/rules",
    text: "zasady"
  },
  {
    img:"/icons/star-half-stroke-solid.svg",
    img_alt: "bs",
    link: "/bs",
    text: "BS"
  },
  {
    img:"/icons/road-solid.svg",
    img_alt: "drive",
    link: "/drive",
    text: "przejazd autokarów"
  },
  {
    img:"/icons/hand-holding-heart-solid.svg",
    img_alt: "insurance",
    link: "/insurance",
    text: "ubezpieczenie"
  },
  {
    img:"/icons/users-viewfinder-solid.svg",
    img_alt: "users",
    link: "/users",
    text: "harcerze"
  }
]

function ZHR() {
    return (
      <>
        <div className="page-title">
          ZHR
        </div>
        <div className="navigation-wraper">
          <nav className="navigation-bar">
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
        </div>
      </>
    );
}

export default ZHR;
